import { Dialog, Button } from "@mui/material";
import RemoveCircleIcon from "../../../assets/icons/RemoveAdmin.svg";

const RevokeAdminModal = ({ show, onClose, onRevoke, user, isSubmitting = false }) => {
  const handleRevoke = async () => {
    if (user) {
      await onRevoke(user);
    }
  };

  return (
    <Dialog
      open={show}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "visible",
        },
      }}
    >
      <div className="pt-8 pb-4 px-4 sm:px-6">
        <div className="text-center p-8 pt-2 rounded-2xl">
          <div className="flex justify-center mb-6">
            <img src={RemoveCircleIcon} alt="revoke icon" loading="eager"/>
          </div>

          <h3 className="text-lg font-bold text-gray-900 mb-2">
            Revoke Admin Access
          </h3>

          <p className="text-sm text-gray-500">
            Are you sure you want to revoke admin access for {user?.name} (
            {user?.role})?
          </p>
          <p className="text-sm text-gray-500">
            They will immediately lose access to the PBXScribe admin panel.
          </p>
        </div>
      </div>

      <div className="flex justify-center gap-3 px-4 sm:px-6 pb-6">
        <Button
          onClick={handleRevoke}
          variant="contained"
          disabled={isSubmitting}
          sx={{
            bgcolor: "#DC2626",
            "&:hover": { bgcolor: "#B91C1C" },
            textTransform: "uppercase",
            fontWeight: 600,
            px: 3,
          }}
        >
          Revoke Access
        </Button>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isSubmitting}
          sx={{
            borderColor: "grey.300",
            color: "text.primary",
            textTransform: "uppercase",
            fontWeight: 600,
            px: 3,
            "&:hover": { borderColor: "grey.400", bgcolor: "grey.50" },
          }}
        >
          Cancel
        </Button>
      </div>
    </Dialog>
  );
};

export default RevokeAdminModal;
